export default "__VITE_ASSET__3234030e__"